export default __webpack_public_path__ + "static/FoodboomLogo-c6ca9746a9b9a82bd343ecf8bd201b64.png";